export default {
    name: '文章',
    url: '/admin/article', // rest接口表名
    query: '&sort=-upload_time', // rest接口query参数
    // 列表渲染列
    columns: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {title: '标题', dataIndex: 'title'},
            {title: '发布时间', dataIndex: 'upload_time'},
        ]
    },
    // 列表查询表单
    queryForm: [
        {
            key: 'title',
            label: '',
            component: 'a-input',
            props: {
                placeholder: '请输入标题查询',
            },
        },
    ],
    // 新增/编辑查询表单
    items: [
        {
            key: 'title',
            label: '文章标题',
            component: 'a-input',
            props: {
                placeholder: '请输入文章标题',
            },
            rules: [{ required: true, message: '请输入文章标题', trigger: 'blur' }]
        },
        {
            key: 'upload_time',
            label: '发布时间',
            component: 'a-date-picker',
            props: {
                showTime: { format: 'HH:mm' },
                format: "YYYY-MM-DD HH:mm",
                valueFormat: "YYYY-MM-DD HH:mm",
                placeholder: "请选择发布时间",
            },
            rules: [{ required: true, message: '请选择发布时间', trigger: 'change' }]
        },
        {
            key: 'source',
            label: '文章来源',
            component: 'a-radio-group',
            props: {
                options: [
                    { label: '跳转链接', value: 1 },
                    { label: '文章发布', value: 2 },
                ]
            },
            listeners: {
                change(e) {
                    let val = e.target.value;
                    if(val) {
                        let i = this.controls.findIndex(c => c.key == 'content' || c.key == 'link_url');
                        let con;
                        if(val == 1) {
                            con = {
                                key: 'link_url',
                                label: '链接地址',
                                component: 'a-input',
                                props: {
                                    placeholder: '请输入链接地址',
                                },
                                rules: [{ required: true, message: '请输入链接地址', trigger: 'blur' }]
                            }
                        } else if(val == 2) {
                            con = {
                                key: 'content',
                                label: '文章内容',
                                component: 'tiny-editor'
                            }
                        }
                        if(i >= 0) {
                            this.controls.splice(i, 1, con);
                        } else {
                            this.controls.push(con);
                        }
                    }
                }
            },
            rules: [{ required: true, message: '请选择文章来源', trigger: 'change' }]
        },
    ],
    // 详情接口expand字段
    expand: '',
    init: { source: 1 }, // 新增实体初始化字段
    // 详情渲染字段
    renderItems: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {
                label: '标题',
                key: 'title',
            },
            {
                label: '发布时间',
                key: 'upload_time',
            },
            {
                label: '文章内容',
                slot: entity => entity.link_url ? <span>跳转链接{entity.link_url}</span> : <div class="rich-preview" v-html={entity.content}></div>
            },
        ]
    },
}
